import { ChangeEvent } from 'react';
import { FormField } from '../FormField';
import './checkField.css';

type CheckFieldProps = {
  label?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  error?: string;
  disabled?: boolean;
  text?: string; // Texto que aparece junto al checkbox
};

export const CheckField = ({
  label,
  checked,
  onChange,
  error,
  disabled,
  text
}: CheckFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    onChange(e.target.checked);
  };

  return (
    <div className="check-field-container">
      <label className="check-field-label">
        <input
          type="checkbox"
          className="check-field-input"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className="check-field-custom"></span>
        {label && <span>{label}</span>}
      </label>
    </div>
  );
};
